import { render } from "./EditBookingForm.vue?vue&type=template&id=40bb0be3"
import script from "./EditBookingForm.vue?vue&type=script&lang=js"
export * from "./EditBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__